import { z } from 'zod';

export const hostingRequestSchema = z.object({
  request: z
    .string()
    .trim()
    .min(1, { message: 'error.required' }),
  name: z
    .string()
    .trim()
    .min(1, { message: 'error.required' }),
  email: z
    .string()
    .trim()
    .min(1, { message: 'error.required' })
    .email({ message: 'marketing.hosting.form.email.error' }),
  contact: z
    .string()
    .trim()
    .optional(),
});

export type HostingRequestFormValues = z.infer<typeof hostingRequestSchema>;

